module.exports = __webpack_public_path__ + "mp3/Beach_Disco.mp3";